// src/constants.js
export const AWS_URL = "https://g-digital.in/api";
// export const AWS_URL= "http://127.0.0.1:5000/api"
